import { render, staticRenderFns } from "./CombinationList.vue?vue&type=template&id=3bf67913&scoped=true"
import script from "./CombinationList.vue?vue&type=script&lang=js"
export * from "./CombinationList.vue?vue&type=script&lang=js"
import style0 from "./CombinationList.vue?vue&type=style&index=0&id=3bf67913&prod&lang=scss&scoped=true"
import style1 from "./CombinationList.vue?vue&type=style&index=1&id=3bf67913&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf67913",
  null
  
)

export default component.exports